/**
 * `tom-select` does not work with older browsers (IE 11) and relies on features that can't be polyfilled (E.g. RegExp unicode flag)
 */

import TomSelect from 'tom-select';
import axios from 'axios';
import 'tom-select/dist/css/tom-select.css';
import './select-search.scss';

const selectSearch = (() => {
  const LANG = document.documentElement.lang;
  const NO_RESULTS = {
    fi: 'Ei hakutuloksia',
    en: 'No results',
    sv: 'Inga resultat'
  };

  /**
   * Initilizes given elements
   * @param {Array} selects native select elements optional
   * @returns {Array} Instances of Tom Select
   */
  function initMultiple(selects) {
    const searchSelects = selects.map((select) => {
      const config = getDefaultConfig();
      const ajaxPath = select.dataset.ajax;
      if(ajaxPath) {
        //load results from backend
        config.loadThrottle = 500;
        config.load = function(query, callback) {
          loadResults(query, callback, ajaxPath);
        };
      }

      return new TomSelect(select, config);
    });

    return searchSelects;
  }

  /**
   * Initilizes given element
   * @param {HTMLElement} select native select element
   * @param {Object} config Tom select configuration
   * @returns {HTMLElement} Tom Select instance
  */
  function initSingle(select, config = {}) {
    const configuration = Object.assign(getDefaultConfig(), config);
    return new TomSelect(select, configuration);
  }

  /**
   * Get config with locatisation setting
   * @returns {Object} Tom Select config
   */
  function getDefaultConfig() {
    return {
      // as a select replacement we don't want to force people to type (default only 50)
      maxOptions: 3000,
      render: {
        no_results: () => {
          return `<div class="no-results">${NO_RESULTS[LANG] || NO_RESULTS.en}</div>`;
        }
      }
    };
  }

  /**
   * Search results
   * @param {string} query search string
   * @param {function} callback TomSelect load callback
   * @param {string} ajaxPath ajax path
   */
  async function loadResults(query, callback, ajaxPath) {
    if(ajaxPath) {
      var url = '/stage-ajax/'+ ajaxPath;
      await axios.get(url, {
        params: {
          q: query,
          'stage-language': LANG,
        }
      }).then((response) => {
        callback(response.data.options);
      }).catch((error) => {
        callback();
      });
    }
  }

  return {
    initSingle,
    initMultiple
  };

})();

export default selectSearch;

